export default class LocationModel {
  locationRequest = ({ signal } = {}) => {
    return fetch(`${process.env.AUTH_HOST}/v1/auth/location`, {
      headers: {
        Accept: "application/json",
        "Content-type": "application/json; charset=utf-8",
      },
      method: "GET",
      signal,
    });
  };
}
